export function formatToEuro(number: number, options?: Intl.NumberFormatOptions) {
    const result = number.toLocaleString(undefined, {
        style: "currency",
        currency: "EUR",
        ...options,
    });
    return result;
}
